import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {HistoricComponent} from './historic.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DirectiveModule} from '~/app/shared/directives/directive.module';
import {MessagesModule} from '@components/messages/messages.module';
import {FavoriteModule} from '@components/favorite/favorite.module';

export const HistoricRoutes: Routes = [
    {path: '', component: HistoricComponent},
];

@NgModule({
    declarations: [
        HistoricComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(HistoricRoutes),
        MatProgressSpinnerModule,
        MatTooltipModule,
        DirectiveModule,
        MessagesModule,
        FavoriteModule,
    ]
})
export class HistoricModule {
}
